<template>
    <div>
    <template v-if="index === intent_index">
        <div class="box" @click="$emit('changIntentIndex',index)">
            <div style="color: #0C2F53;font-weight: 400;font-size: 14px; cursor: default;">{{ index + 1 }}</div> 
        </div>
    </template>
    <template v-else>
        <div @click="$emit('changIntentIndex',index)" 
        style="width: 32px !important; height: 32px !important; border-radius: 5px !important; background: #FFFFFF !important; border: 1px solid #BDBDBD !important; display: flex; justify-content: center; align-items: center;cursor: pointer;" >
          <div style="color: #BDBDBD;font-weight: 400;font-size: 14px; cursor: pointer;">{{ index + 1 }}</div>    
        </div>
    </template>
</div>
  </template>
  <script>
  import Typography from '../../elements/Typography.vue'
  
  export default {
    components: { Typography },
    data: function() {
      return {}
    },
    props: {
        intent_index: Number,
      data: Array,
      index: Number,     
    },
    mounted: function() {

    },
    methods: {

    }
  }
  </script>
  <style scoped>
  .box {
      width: 32px !important;
      height: 32px !important; 
      border-radius: 5px !important;
      /* background: #FFFFFF !important; */
      border: 1px solid #0C2F53 !important;
      display: flex;
      justify-content: center;
      align-items: center;
  }
  .flex-addChatbot {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 6px;
  }
  </style>
  


// WEBPACK FOOTER //
// src/components/view/welcomemessage/PaginationChatbot.vue